import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderInteger,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
} from "./RenderUtils";

export class DeleteVehicleRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          <label className="quote-change-label">VEHICLE TO BE DELETED</label>
          {renderInteger(
            "vehicleYear",
            "Vehicle Year",
            request,
            updateRequest,
            "e.g. 1958",
            { ignoreServerValidation: true }
          )}
          {renderTextBox(
            "vehicleMake",
            "Vehicle Make",
            request,
            updateRequest,
            "Ford"
          )}
          {renderTextBox(
            "vehicleModel",
            "Vehicle Model",
            request,
            updateRequest,
            "Pinto"
          )}
          {renderTextBox(
            "vehicleVin",
            "Vehicle VIN Number",
            request,
            updateRequest,
            "VIN123456789"
          )}
          {renderTextBox("vehicleType", "Vehicle Type", request, updateRequest)}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
